module.exports = __webpack_public_path__ + "static/img/emotions1_12.b68d7b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/images/emotions1_12.png
// module id = /zeu
// module chunks = 0